import {useChecklistData} from "../ChecklistDataContext";
import {renderElement} from "../renderElement";
import styles from "../checklist.module.css";

export const CheckItemIngress = ({ingress}: {ingress: string}) => {
    const {itemsState} = useChecklistData();

    return (
        <div className={styles.ingressSection}>
            <div className={styles.contentBody}>
                {renderElement(ingress, itemsState.elements, itemsState.objects)}
            </div>
        </div>
    );
};
